module.exports = __webpack_public_path__ + "static/media/carroussel_05.9a79b1e0.jpg";